import { render, staticRenderFns } from "./CourseProgressBar.vue?vue&type=template&id=2b5eb0b1&scoped=true"
import script from "./CourseProgressBar.vue?vue&type=script&lang=js"
export * from "./CourseProgressBar.vue?vue&type=script&lang=js"
import style0 from "./CourseProgressBar.vue?vue&type=style&index=0&id=2b5eb0b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5eb0b1",
  null
  
)

export default component.exports